import { lazy } from 'react';

export const Promotions = lazy(() => import(/* webpackChunkName: "promotions" */ './promotions-container'));
export const PromotionsV3 = lazy(() => import(/* webpackChunkName: "promotions" */ './promotions-v3-container'));
